import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import LoadingView from "../views/LoadingView";
import SpaceBalanceView from "../views/SpaceBalanceView";
import SpaceBalanceStore from "../../stores/SpaceBalanceStore";


export default class SpaceBalanceContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "spaceBalanceStore": SpaceBalanceStore.getState()
        }
    }

    componentDidMount() {
        this.spaceBalanceStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.SPACE_BALANCE_STORE_UPDATE, this.handleStoreUpdate);
        EventPublisher.publish(
            UIInteractionEvents.SPACE_BALANCE_MOUNTED, {
                selectedYear: this.state.spaceBalanceStore.selectedYear,
                selectedMonth: this.state.spaceBalanceStore.selectedMonth
            });
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.spaceBalanceStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.SPACE_BALANCE_UNMOUNTED, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "spaceBalanceStore": SpaceBalanceStore.getState()
        });
    };

    render() {
        if (this.state.spaceBalanceStore.loadingState === LoadingStates.INITIALIZED ||
            this.state.spaceBalanceStore.loadingState === LoadingStates.LOADING
        ) {
            return (
                <LoadingView titleText="Loading Balance Events"/>
            );
        }

        return (
            <SpaceBalanceView
                selectedMonth={this.state.spaceBalanceStore.selectedMonth}
                selectedYear={this.state.spaceBalanceStore.selectedYear}
                priorEarnings={this.state.spaceBalanceStore.monthBalanceEvents.priorEarnings}
                priorPayouts={this.state.spaceBalanceStore.monthBalanceEvents.priorPayouts}
                earningsEvents={this.state.spaceBalanceStore.monthBalanceEvents.earningsEvents}
                payoutEvents={this.state.spaceBalanceStore.monthBalanceEvents.payoutEvents}
            />
        );
    }


}